export const FONT_FAMILY_NAME = 'Lato';
